import Slideshow from "./Slideshow";
import "./AboutSection.css";

function AboutSection() {
  return (
    <section className="about-section">
      <h2 className="header-text">фото / photo</h2>
      <Slideshow />
    </section>
  );
}

export default AboutSection;
